import { RecoilRoot } from "recoil";
import { RouterProvider } from "react-router-dom";
import { routers } from "./router/router";
import { CookiesProvider } from "react-cookie";

import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
// import "./i18n"; // i18n 초기화

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      useErrorBoundary: true,
    },
  },
});

function App() {
  // 언어 초기세팅
  // languageRouteInit();

  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools position="bottom-right" />
        <RecoilRoot>
          <RouterProvider router={routers} />
        </RecoilRoot>
      </QueryClientProvider>
    </CookiesProvider>
  );
}

export default App;
